import { useState } from "react";
import { Run } from "./Run";
import { createEntityStore } from "../../common/entityStore";
import { FormControlLabel, Grid, Radio } from "@mui/material";
import { propBoolField, propFileField, propNumberField, propRadioGroup } from "../../common/entityStoreForm";
import { combine, propIf, propInt, propRequired, propValidValue, propValueValidator } from "../../common/entityStoreValidators";

enum ImportType {
    Standard = 1,
    Dtd = 2,
    Tm = 3,
    Web = 4,
}

export function OrderImportRunPage() {
    const [useParamsStore] = useState(() => createEntityStore<RunParams>({
        data: { checkQrp: false },
        id: null,
        propValidators: [
            propRequired("file"),
            propRequired("importTypeUi"),
            propIf(p => p.importType === ImportType.Standard && p.checkQrp, () => combine([
                propValidValue("daysFromLastOrder", "daysFromLastOrderFormatted"),
                propRequired("daysFromLastOrder"),
                propInt("daysFromLastOrder"),
            ])),
            propIf(p => p.importType === ImportType.Standard && p.checkQrp, () => combine([
                propValidValue("numberOfPaidShipments", "numberOfPaidShipmentsFormatted"),
                propRequired("numberOfPaidShipments"),
                propInt("numberOfPaidShipments"),
            ])),
            propValueValidator("isFileImported", p => p && "File is already imported."),
        ]
    }));
    const { showQrp, checkQrp } = useParamsStore(p => ({ showQrp: p.clientData.importType === ImportType.Standard, checkQrp: p.clientData.checkQrp }));
    const [isRunning, setIsRunning] = useState(false);
    function renderParams() {
        return <>
            <Grid item xs={12}>{propFileField(useParamsStore)("file", "File", { disabled: isRunning, onChange: () => useParamsStore.getState().setClientDataProp("isFileImported", undefined) })}</Grid>
            <Grid item xs={12}>{propRadioGroup(useParamsStore)<number | undefined>("importTypeUi", "Import type", p => Number(p), {
                children: <Grid container>
                    <Grid item xs={6}><FormControlLabel value={ImportType.Standard} control={<Radio />} label="Standard" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={-ImportType.Standard} control={<Radio />} label="Standard new" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={ImportType.Dtd} control={<Radio />} label="DtD" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={-ImportType.Dtd} control={<Radio />} label="DtD new" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={ImportType.Tm} control={<Radio />} label="Reactivation" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={-ImportType.Tm} control={<Radio />} label="Reactivation new" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={ImportType.Web} control={<Radio />} label="Web" /></Grid>
                    <Grid item xs={6}><FormControlLabel value={-ImportType.Web} control={<Radio />} label="Web new" /></Grid>
                </Grid>,
                onChange: p => {
                    useParamsStore.getState().setClientDataProp("importType", p == null ? undefined : Math.abs(p));
                    useParamsStore.getState().setClientDataProp("isNewImportType", p == null ? undefined : p < 0);
                }
            })}</Grid>
            {showQrp && <>
                <Grid item xs={12}>{propBoolField(useParamsStore)("checkQrp", "QRP Hunter control")}</Grid>
                <Grid item xs={12}>{propNumberField(useParamsStore)("daysFromLastOrder", "daysFromLastOrderFormatted", "Days from last order", { disabled: !checkQrp })}</Grid>
                <Grid item xs={12}>{propNumberField(useParamsStore)("numberOfPaidShipments", "numberOfPaidShipmentsFormatted", "Number of paid shipments", { disabled: !checkQrp })}</Grid>
            </>}
        </>;
    }
    return <Run name="Order import" hub="orderImportRun" onRunFinished={p => p && useParamsStore.getState().setClientDataProp("isFileImported", true)}
        useParamsStore={useParamsStore} renderParams={renderParams} setIsRunning={setIsRunning} />;
}

interface RunParams {
    file?: File;
    isFileImported?: boolean;
    importTypeUi?: number;
    importType?: ImportType;
    isNewImportType?: boolean;
    checkQrp: boolean;
    daysFromLastOrder?: number;
    daysFromLastOrderFormatted?: string;
    numberOfPaidShipments?: number;
    numberOfPaidShipmentsFormatted?: string;
}
